import PropTypes from 'prop-types';
import React from 'react';
import { shouldComponentUpdate } from '../shallow_equal';

export default class Title extends React.Component {
    static displayName = 'Title';

    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.string,
            // <Title>All notes for {content.title}</Title>
            // The code above produces an array of text nodes
            PropTypes.array,
        ]).isRequired,
    };

    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdate(this, nextProps, nextState);
    }

    componentWillUnmount() {
        document.title = this.titleBackup;
    }

    UNSAFE_componentWillMount() {
        this.titleBackup = document.title;
    }

    render() {
        let title = '';

        React.Children.forEach(this.props.children, child => {
            title += child;
        });

        document.title = title;
        // At least with React 0.13, returning null here causes React to replace
        // the `<noscript` placeholder every time.
        // TODO: Try null here when we upgrade to React 15
        return <span />;
    }
}



// WEBPACK FOOTER //
// ./src/components/title.jsx